"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class GroupType extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'groupType';
        this._name = initParams.name;
        this._icon = initParams.icon;
        this._color = initParams.color;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateGroupType(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set icon(value) {
        console.error('Do not set objects this way');
    }
    setIcon(value) {
        return this.dataService.updateGroupType(this.id, { icon: value }, this);
    }
    get icon() {
        return this._icon;
    }
    set color(value) {
        console.error('Do not set objects this way');
    }
    setColor(value) {
        return this.dataService.updateGroupType(this.id, { color: value }, this);
    }
    get color() {
        return this._color;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateGroupType(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteGroupType(this.id, this);
    }
}
exports.default = GroupType;
//# sourceMappingURL=groupType.js.map